import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9d5cc312"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon-hover" }
const _hoisted_2 = { style: {
          height: '204px',
          overflow: 'hidden',
        } }
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = { style: { display: 'flex', alignItems: 'center', color: '#1D2129' } }

import { IconShareInternal } from "@arco-design/web-vue/es/icon";
import API from "@/api";

import router from "@/router";

interface Props {
  app: API.AppVO;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppCart',
  props: {
    app: { default: () => {
    return {};
  } }
  },
  setup(__props: any) {

const props = __props;
/**
 * 进入应用
 */
const clickApp = () => {
  router.push({
    path: `/app/detail/${props.app.id}`,
  });
};

return (_ctx: any,_cache: any) => {
  const _component_IconHeartFill = _resolveComponent("IconHeartFill")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_card_meta = _resolveComponent("a-card-meta")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    class: "appCart",
    style: { width: '300px' },
    onClick: clickApp
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_a_space, null, {
        default: _withCtx(() => [
          _createVNode(_component_IconHeartFill, { style: {"margin-top":"-3px"} }),
          _createVNode(_component_a_typography_text, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.app.thumbNum), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_unref(IconShareInternal))
      ])
    ]),
    cover: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          style: {
            width: '100%',
            height: '100%',
            transform: 'translateY(-20px)',
          },
          alt: _ctx.app.appName,
          src: _ctx.app.appIcon
        }, null, 8, _hoisted_3)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_card_meta, {
        title: _ctx.app.appName,
        description: _ctx.app.appDesc,
        style: {"margin-top":"-20px"}
      }, {
        avatar: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_avatar, {
              size: 24,
              style: { marginRight: '8px' },
              "image-url": _ctx.app.user?.userAvatar
            }, null, 8, ["image-url"]),
            _createVNode(_component_a_typography_text, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.app.user.userName), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["title", "description"])
    ]),
    _: 1
  }))
}
}

})